module.exports = __webpack_public_path__ + "img/SplashScience1.a1bdb6f7.jpg";